import { isEmpty } from 'lodash'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { UseKeysEventsProps } from '#/components/AdvancedSearch/types'

/** Atalhos de teclado do modal: Alt+S e Esc, navegação com setas e Enter */
export function useKeysEvents({
  activeIndex,
  filteredResults,
  open,
  setActiveIndex,
  setOpen,
}: UseKeysEventsProps) {
  const history = useHistory()

  /** Atalhos globais: Alt+S abre o modal, Esc fecha */
  useEffect(() => {
    const handleGlobalKeys = (event: KeyboardEvent) => {
      const key = event.key

      if (event.altKey && (key === 's' || key === 'S' || event.code === 'KeyS')) {
        event.preventDefault()
        event.stopPropagation()
        setOpen(true)
        return
      }

      if (key === 'Escape' || event.code === 'Escape') {
        event.preventDefault()
        event.stopPropagation()
        setOpen(false)
      }
    }

    // Captura o evento antes de listeners que possam interromper a propagação
    document.addEventListener('keydown', handleGlobalKeys, { capture: true })
    return () => document.removeEventListener('keydown', handleGlobalKeys, { capture: true })
  }, [setOpen])

  /** Navegação na lista de resultados: setas movem a seleção, Enter acessa o item */
  useEffect(() => {
    if (!open || isEmpty(filteredResults)) return

    const lastIndex = filteredResults.length - 1
    const handleNavigation = (e: KeyboardEvent) => {
      switch (e.key) {
        case 'ArrowDown': {
          // Sem seleção começa no primeiro item; avança parando no último
          e.preventDefault()
          setActiveIndex(prev => (prev === null ? 0 : Math.min(prev + 1, lastIndex)))
          break
        }

        case 'ArrowUp': {
          // Sem seleção, inicia no último; recua parando no primeiro
          e.preventDefault()
          setActiveIndex(prev => (prev === null ? lastIndex : Math.max(prev - 1, 0)))
          break
        }

        case 'Enter': {
          if (activeIndex === null) return
          const item = filteredResults[activeIndex]
          if (item?.link) history.push(item.link)
          setOpen(false)
          break
        }
      }
    }

    document.addEventListener('keydown', handleNavigation)
    return () => document.removeEventListener('keydown', handleNavigation)
  }, [open, filteredResults, activeIndex, setActiveIndex, history, setOpen])
}
